import React, { Component } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
  MenuItem,
} from "@mui/material";
import Sidebar from "./Sidebar";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import base from "../base.json";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Appbar from './Appbar'



const drawerWidth = 80;
export class Edit_Property extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",

      property_thumbnail_img: "",
      poperty_posted_at_date: Date(),
      property_video: "",
      property_imagelist: [],
      property_imagelistcc :[],

      property_area_pincode: "",
      property_local_area: "",
      property_area_name: "",
      property_street_name: "",
      property_city_name: "",
      property_district: "",
      property_state: "",
      property_name: "",

      property_type:"",

      property_category: "",

      no_of_bed_room: "",
      construction_status: "",

      property_area: "",
      property_price: "",

      is_verified: false,

      is_switch_case: true,
    };
    this.handleChange = this.handleChange.bind();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChangee = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

  handleChangeee = (e) => {
    this.setState({
      [e.target.name]: e.target.files, property_imagelistcc:[]
    });
  };


  
async componentDidMount(){
         let  m =  await sessionStorage.getItem("data")
    let  ll = JSON.parse(m)

    this.setState({
      builder_id : ll[0].builder_id
    })

 fetch(
           `${base.base_url}/property_portal/vendor_portal/property/getSingleProeprtydetails`,
           {headers: {
                      "Content-Type":"application/json"
                        },
             method: "post",
             body:JSON.stringify({
              id : this.props.param.id.replace(/:/g, "")
             })
           }
          )
           .then((res) => {
             return res.json();
           })
           .then((result) => {
  
             this.setState({
        id: result.data._id,

      property_thumbnail_img: result.data.property_thumbnail_img,
      property_video: result.data.property_video,
      property_type:result.data.property_type,
      
      property_imagelist: [],
      property_imagelistcc:result.data.property_imagelist,

      property_area_pincode: result.data.property_area_pincode,
      property_local_area: result.data.property_local_area,
      property_area_name: result.data.property_area_name,
      property_street_name: result.data.property_street_name,
      property_city_name: result.data.property_city_name,
      property_district: result.data.property_district,
      property_state: result.data.property_state,
      property_name: result.data.property_name,

      property_category: result.data.property_category,

      no_of_bed_room: result.data.no_of_bed_room,
      construction_status: result.data.construction_status,

      property_area: result.data.property_area,
      property_price: result.data.property_price,
             })
           })
}


instantRetrive=()=>{
  
 fetch(
           `${base.base_url}/property_portal/vendor_portal/property/getSingleProeprtydetails`,
           {headers: {
                      "Content-Type":"application/json"
                        },
             method: "post",
             body:JSON.stringify({
              id : this.props.param.id.replace(/:/g, "")
             })
           }
          )
           .then((res) => {
             return res.json();
           })
           .then((result) => {
  
             this.setState({
        id: result.data._id,
          property_type:result.data.property_type,
      property_thumbnail_img: result.data.property_thumbnail_img,
      property_video: result.data.property_video,

      property_imagelist: [],
      property_imagelistcc:result.data.property_imagelist,

      property_area_pincode: result.data.property_area_pincode,
      property_local_area: result.data.property_local_area,
      property_area_name: result.data.property_area_name,
      property_street_name: result.data.property_street_name,
      property_city_name: result.data.property_city_name,
      property_district: result.data.property_district,
      property_state: result.data.property_state,
      property_name: result.data.property_name,

      property_category: result.data.property_category,

      no_of_bed_room: result.data.no_of_bed_room,
      construction_status: result.data.construction_status,

      property_area: result.data.property_area,
      property_price: result.data.property_price,
             })
           })
}



  save = () => {
    if (
      this.state.id!= "" &&
      this.state.property_thumbnail_img!= "" &&
      this.state.poperty_posted_at_date!= "" &&
      this.state.property_video != "" &&
      (this.state.property_imagelist.length > 0 || this.state.property_imagelistcc.length > 0) &&
      this.state.property_area_pincode != "" &&
      this.state.property_local_area != "" &&
      this.state.property_area_name != "" &&
      this.state.property_street_name != "" &&
      this.state.property_city_name != "" &&
      this.state.property_district != "" &&
      this.state.property_state != "" &&
      this.state.property_name != "" &&
      this.state.property_category != "" &&
      this.state.no_of_bed_room != "" &&
      this.state.construction_status != "" &&
      this.state.property_area != "" &&
      this.state.property_price != ""
    ) {
      let formdata = new FormData();




      for (
        let index = 0;
        index < this.state.property_imagelist.length;
        index++
      ) {
        formdata.append(
          "property_imagelist",
          this.state.property_imagelist[index]
        );
      }



if(this.state.property_imagelistcc.length>0){
      formdata.append("property_imagelistcc",JSON.stringify(this.state.property_imagelistcc));
}



      formdata.append("id", this.state.id);
      formdata.append(
        "property_thumbnail_img",
        this.state.property_thumbnail_img
      );
      formdata.append("property_video", this.state.property_video);
      formdata.append(
        "property_area_pincode",
        this.state.property_area_pincode
      );
      formdata.append("property_local_area", this.state.property_local_area);
      formdata.append("property_area_name", this.state.property_area_name);
      formdata.append("property_street_name", this.state.property_street_name);
      formdata.append("property_city_name", this.state.property_city_name);
      formdata.append("property_district", this.state.property_district);

      formdata.append("property_type", this.state.property_type);

      formdata.append("property_state", this.state.property_state);

      formdata.append("property_name", this.state.property_name);

      formdata.append("property_category", this.state.property_category);
      //////// id information
      formdata.append("no_of_bed_room", this.state.no_of_bed_room);
      formdata.append("construction_status", this.state.construction_status);

      formdata.append("property_area", this.state.property_area);

      //////// Financial Details
      formdata.append("property_price", this.state.property_price);

      this.setState({ is_loader_shows: true }, () => {
        fetch(
          `${base.base_url}/property_portal/vendor_portal/property/updatePropertyDetails`,
          {
            /*
        headers: {
                                "content-type": "multipart/form-data",
                              },
                              */
            method: "put",
            body: formdata,
          }
        )
          .then((res) => {
            return res.json();
          })
          .then(() => {
            alert("Updated")
            this.instantRetrive()

          });
      });
    } else {
      alert("fill all fields");
    }
  };


 isObject=(o)=> {
  return o instanceof Object && typeof o.constructor === 'function';
}


  render() {
    return (
      <Box>
        <Appbar/>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            <Box
              sx={{
                height: 47,
                //  width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: 18, ml: 1 }}>
                Edit Property Details
              </Typography>

              <Link to="/admin/propertyList">
                <Button
                  variant="contained"
                  size="samll"
                  startIcon={
                    <FormatListNumberedOutlinedIcon
                      sx={{ height: 20, width: 20 }}
                    />
                  }
                  disableElevation
                  sx={{
                    height: 25,
                    fontSize: 13,
                    textTransform: "none",
                    backgroundColor: "#288ade",
                    mr: 1,
                  }}
                >
                  Property List
                </Button>
              </Link>
            </Box>

            <Box
              sx={{
                pl: { xs: 1, sm: 3 },
                pt: { xs: 1, sm: 3 },
                pr: { xs: 1, sm: 3 },
                display: this.state.is_switch_case ? "block" : "none",
              }}
            >
              <Box>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Fill property details
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Builder Id
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Builder id"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_id"
                          value={this.state.builder_id}
                          
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Select property category
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Property category"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          select
                          name="property_category"
                          value={this.state.property_category}
                          onChange={this.handleChange}
                        >
                          {[
                            "FLATS",
                            "COMMERCIAL",
                            "LAND",
                            "INDEPENDENT HOUSE",
                          ].map((option) => (
                            <MenuItem
                              sx={{ fontSize: 11, fontWeight: "bold" }}
                              key={option}
                              value={option}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>


                                 <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                                              <Typography
                                                sx={{
                                                  fontSize: 11,
                                                  color: "#515151",
                                                  fontWeight: "bold",
                                                  p: 0.5,
                                                }}
                                              >
                                                Select property type
                                              </Typography>
                                              <TextField
                                                size="small"
                                                fullWidth
                                                
                                                placeholder="Property type"
                                                InputProps={{
                                                  style: { fontSize: 11, fontWeight: "500" },
                                                }}
                                                select
                                                name="property_type"
                                                value={this.state.property_type}
                                                onChange={this.handleChange}
                                              >
                                                {[
                                                  "ON RENT",
                                                  "ON SALE",
                                                  "ON LEASE",
                                                ].map((option) => (
                                                  <MenuItem
                                                    sx={{ fontSize: 11, fontWeight: "bold" }}
                                                    key={option}
                                                    value={option}
                                                  >
                                                    {option}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </Grid>
                      

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          No of bed room
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="No of bed room"
                          fullWidth
                          select
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="no_of_bed_room"
                          value={this.state.no_of_bed_room}
                          onChange={this.handleChange}
                        >
                          {[
                            "1 RK",
                            "1 BHK",
                            "2 BHK",
                            "3 BHK",
                            "4 BHK",
                            "5 BHK",
                            "6 BHK",
                          ].map((option) => (
                            <MenuItem
                              sx={{ fontSize: 11, fontWeight: "bold" }}
                              key={option}
                              value={option}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Construction status
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Construction status"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          select
                          name="construction_status"
                          value={this.state.construction_status}
                          onChange={this.handleChange}
                        >
                          {[
                            "NEW LAUNCH",
                            "UNDER CONSTRUCTION",
                            "READY TO MOVE",
                          ].map((option) => (
                            <MenuItem
                              sx={{ fontSize: 11, fontWeight: "bold" }}
                              key={option}
                              value={option}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property area (SQ.FT)
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Property area"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="property_area"
                          value={this.state.property_area}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property price
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Property Price"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="property_price"
                          value={this.state.property_price}
                          onChange={(e) =>
                            this.setState({
                              property_price:
                                e.target.value >= 0 ? e.target.value : 0,
                            })
                          }
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property Thumbnail image
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            name="property_thumbnail_img"
                            onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                         <Link style={{fontSize:10,color:'#008ffb'  }} onClick={()=>window.open(base.base_url+'/'+this.state.property_thumbnail_img)}  >{this.isObject(this.state.property_thumbnail_img)? "":this.state.property_thumbnail_img}</Link>

                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property video
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                           
                          }}
                        >
                          <input
                            type="file"
                            name="property_video"
                            onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>

                        <Link style={{fontSize:10,color:'#008ffb'}} onClick={()=>window.open(base.base_url+'/'+this.state.property_video)}  >{this.isObject(this.state.property_video)? "": this.state.property_video}</Link>

                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property ImageList
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            multiple
                            name="property_imagelist"
                            onChange={this.handleChangeee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                        <Typography sx={{ fontSize: 10, color: "grey", m: 1 }}>
                          Upload Max 1MB, JPG or PNG.
                        </Typography>


                         <Box sx={{display:'flex',flexDirection:'column'}}>
                           {
                            this.state.property_imagelistcc.map((s,i)=>(

                              <Link style={{fontSize:10,color:'#008ffb',marginBottom:0.5}} onClick={()=>window.open(base.base_url+'/'+s.img_url)}  >{i+1}--{s.img_url}</Link>

                            ))
                           }

                         </Box>


                      </Grid>
                    </Grid>

                    <br />
                    <Divider />

                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 10,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Property Address
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Area pincode
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="property_area_pincode"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="property_area_pincode"
                          value={this.state.property_area_pincode}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Local area
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Local area"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="property_local_area"
                          value={this.state.property_local_area}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property area name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Property area name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="property_area_name"
                          value={this.state.property_area_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property street name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Property street name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="property_street_name"
                          value={this.state.property_street_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property city name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Property city name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="property_city_name"
                          value={this.state.property_city_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property state name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Property state name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="property_state"
                          value={this.state.property_state}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property district name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Property district name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="property_district"
                          value={this.state.property_district}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Property name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Property name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="property_name"
                          value={this.state.property_name}
                          onChange={this.handleChange}
                        />
                      </Grid>
                    </Grid>

                    <br />

                    <Box>
                      <Button
                        size="small"
                        variant="contained"
                        sx={{ textTransform: "none", fontSize: 12 }}
                        onClick={this.save}
                      >
                        Edit Property Details
                      </Button>
                    </Box>
                  </Box>
                </Paper>
              </Box>

              <br />
              <br />
              <br />
            </Box>
          </Box>
        </Box>
      </Box>
      </Box>
    );
  }
}

export default Edit_Property;

export function Edit_Propertyc(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  return <Edit_Property param={param} navigate={navigate}></Edit_Property>;
}


